import Marquee from "react-fast-marquee";

const ITEMS = [
  "Sea Safari",
  "High-Speed RIB Tours",
  "Kayaking",
  "Stand-Up Paddleboarding",
  "Beach Sauna & Seaweed",
  "Bushcraft",
  "Raft Building",
  "Island Walks",
  "Wildlife Encounters",
];

export default function MarqueeStrip() {
  return (
    <section
      data-testid="marquee-strip"
      aria-label="Our adventures"
      className="relative z-20 border-y border-gold/20 bg-navy-950 py-6"
    >
      <Marquee speed={55} gradient gradientColor="#060d18" gradientWidth={140}>
        {ITEMS.map((item, i) => (
          <span key={item} className="flex items-center">
            <span
              className={`mx-7 whitespace-nowrap sm:mx-9 ${
                i % 2 === 1
                  ? "font-serif text-lg italic text-gold"
                  : "text-[13px] uppercase tracking-[0.3em] text-ivory/85"
              }`}
            >
              {item}
            </span>
            <span className="inline-block h-1.5 w-1.5 rotate-45 bg-gold/60" aria-hidden="true" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
